import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9cfe04e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-payment-card-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning" }, " Development environment. Do not use real card information. ", -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "card-number col-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Card number", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "card-expires col-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Expires", -1))
const _hoisted_10 = { class: "card-code col-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "CVV", -1))

import { computed, ref, watch } from 'vue'
import { PaymentCardInfoChange, PaymentCardInfoSubmitResult } from './PaymentCardInfo'
import { usePaymentMethodStore } from '@/gp/PaymentMethodStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalPaymentCardInfo',
  emits: [
  'change',
],
  setup(__props, { expose: __expose, emit }) {



const readyRef = ref(true)
const cardNumberRef = ref('')
const cardExpRef = ref('')
const cardCodeRef = ref('')

const paymentMethodStore = usePaymentMethodStore()

const cardExpMonthRef = computed(() => cardExpRef.value?.split('/')[0])
const cardExpYearRef = computed(() => cardExpRef.value?.split('/').at(1) ?? '0')
const cardNumberErrorRef = computed(() => cardNumberRef.value.length < 16 ? 'Incomplete card number' : undefined)
const cardExpErroRef = computed(() => cardExpRef.value?.match(/^\d{2}\/\d{2}$/) ? undefined : 'Invalid expiration date')
const cardCodeErrorRef = computed(() => cardCodeRef.value.length < 3 ? 'Incomplete CVV' : undefined)
const isValidRef = computed(() => !cardNumberErrorRef.value && !cardExpErroRef.value && !cardCodeErrorRef.value)

__expose({
  ready: readyRef,
  submitAsync,
})

function onlyChars(e: KeyboardEvent, pattern: RegExp) {
  if (!e.key.match(pattern) && e.key != 'Backspace') {
    e.preventDefault()
  }
}

watch([cardNumberRef, cardExpRef, cardCodeRef], () => {
  const errorMessage = cardNumberErrorRef.value ?? cardExpErroRef.value ?? cardCodeErrorRef.value
  const event: PaymentCardInfoChange = {
    error: errorMessage ? { message: errorMessage } : undefined,
    complete: isValidRef.value,
  }
  emit('change', event)
}, { immediate: true})

async function submitAsync(intentId: string, clientSecret: string): Promise<PaymentCardInfoSubmitResult> {
  if (!readyRef.value)
    throw 'Component not ready'

  if (!isValidRef.value)  
    return { error: { message: 'Invalid card information' } }
  
  const paymentInfo = {
    cardNumber: cardNumberRef.value,
    expirationMonth: +cardExpMonthRef.value,
    expirationYear: +cardExpYearRef.value + 2000,
  }
  await paymentMethodStore.confirmLocalPayment(paymentInfo, intentId, clientSecret)
  return {}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            maxlength: "16",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cardNumberRef).value = $event)),
            onKeypress: _cache[1] || (_cache[1] = e => onlyChars(e, /[0-9]/))
          }, null, 544), [
            [_vModelText, cardNumberRef.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            maxlength: "5",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cardExpRef).value = $event)),
            onKeypress: _cache[3] || (_cache[3] = e => onlyChars(e, /[0-9/]/))
          }, null, 544), [
            [_vModelText, cardExpRef.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            maxlength: "3",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cardCodeRef).value = $event)),
            onKeypress: _cache[5] || (_cache[5] = e => onlyChars(e, /[0-9]/))
          }, null, 544), [
            [_vModelText, cardCodeRef.value]
          ])
        ])
      ])
    ])
  ]))
}
}

})